
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/parenting-neurosis",
      function () {
        return require("private-next-pages/blog/parenting-neurosis.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/parenting-neurosis"])
      });
    }
  